//Angular
import { Component, OnInit, ViewContainerRef, Compiler, Inject, Renderer } from "@angular/core";
import { Router } from "@angular/router";


//Services
import { LanguageService } from "./../../../../services/cms/language.service";
import { InfoRequestService } from "./../../../../services/cms/info-request.service";
import { ComponentHelperService } from "./../../../../services/core/component-helper.service";
import { SeoService } from "./../../../../services/core/seo.service";
import { CmsComponentService } from "./../../../../services/cms/cms-component.service";
import { ScriptService } from "./../../../../services/cms/script.service";
import { RoutesService } from "../../../../services/core/routes.service";
import { BreadcrumbsService } from '../../../../services/cms/breadcrumbs.service';

//Models
import { Configuration } from "./../../../../models/core/configuration";
import { HttpParam } from "./../../../../models/core/http-param";
import { Company } from "./../../../../models/core/company";
import { InfoRequest } from "./../../../../models/cms/info-request";
import { SeoViewModel } from "./../../../../models/core/seo";
import { Breadcrumbs } from '../../../../models/cms/breadcrumbs';

import { Subscription } from 'rxjs/Subscription';
import { DOCUMENT } from "@angular/platform-browser";

@Component({
    template: ""
})

export class InfoRequestComponent implements OnInit {
    constructor
        (
            private _compiler: Compiler,
            private componentHelper: ComponentHelperService,
            private _elementRef: ViewContainerRef,
            private languageService: LanguageService,
            private infoRequestService: InfoRequestService,
            private cmsComponentService: CmsComponentService,
            @Inject('isBrowser') private isBrowser: boolean,
            private seo: SeoService,
            private renderer: Renderer,
            @Inject(DOCUMENT) private document: any,
            private scriptService: ScriptService
        ) { }

    lang: string = this.languageService.getLongLang();

    subManager = new Subscription();

    ngOnInit() {
        let templateHtml: string;
        let header: any;
        let headDataSub = this.cmsComponentService.getHeaderData().subscribe(result => {
            header = result;
            let SideMenuData = this.cmsComponentService.getSideMenuData().subscribe(result1 => {
                if (result1.Categories) {
                    header.Categories = result1.Categories;

                }
            });
            this.subManager.add(SideMenuData);
        });
        this.subManager.add(headDataSub);
        let infoSub = this.infoRequestService.getInfoRequestData(this.lang).subscribe(result => {
            if (result.SeoInformation) {
                result.SeoInformation.ShortDescription = result.ShortDescription ? result.ShortDescription : '';
                result.SeoInformation.LongDescription = result.LongDescription ? result.LongDescription : '';
            }

            if (this.isBrowser) {

                //templateHtml = result;
                //Creating subcomponent whith the selected template to inject
                let subComponent = this.createSubComponent(result, header);
                //injecting created component (OK)
                this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);
            }
            else {
                //-- Get head and body scripts
                this.scriptService.setupExternalScripts(result, this.scriptService.typeSystemPage, this.scriptService.infoRequestId);

                //-- Setting SEO data for server side rendering, so it is visible for indexers and crawlers
                this.seo.setSeoMetaData(this.document, this.renderer, result.SeoInformation)
                this.seo.generateSeoDomServerSide(this.document, this.renderer, result.SeoInformation);
            }
        });

        this.subManager.add(infoSub);
    }

    ngOnDestroy() {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    }

    private createSubComponent(componentInfo: any, header: any) {

        @Component({
            template: componentInfo.TemplateHtml

        })

        class ChildComponent implements OnInit {
            constructor
                (
                    private infoRequestService: InfoRequestService,
                    private seoService: SeoService,
                    private router: Router,
                    private _elementRef: ViewContainerRef,
                    private scriptService: ScriptService,
                    @Inject('isBrowser') private isBrowser: boolean,
                    private routesService: RoutesService,
                    private breadcrumbsService: BreadcrumbsService
                ) { }

            private configuration: Configuration;
            private infoRequestFailed: boolean;
            private infoRequestSuccess: boolean;
            private model: InfoRequest;
            private company: Company = componentInfo.Company;

            private pageIsInit: boolean = false;
            private spinnerContact: boolean = false;
            private breadcrumbs: Breadcrumbs[] = componentInfo.BreadcrumbsInfo;
            footerData: any = componentInfo.footerData;
            headerData: any = header;
            subManager = new Subscription();

            onSubmit(form) {
                this.spinnerContact = true;

                if (form.valid) {
                    let infoSub = this.infoRequestService.sendInfoRequest(this.model).subscribe(result => {
                        if (result) {
                            this.infoRequestSuccess = true;
                            this.infoRequestFailed = false;
                            this.spinnerContact = false;
                        }

                        else {
                            this.infoRequestFailed = true;
                            this.infoRequestSuccess = false;
                            this.spinnerContact = false;
                        }
                    });

                    this.subManager.add(infoSub);
                }

                else {
                    this.infoRequestFailed = true;
                    this.infoRequestSuccess = false;
                    this.spinnerContact = false;
                }
            }

            private seoInfo: SeoViewModel = componentInfo.SeoInformation;

            ngOnInit() {
                setTimeout(x => this.breadcrumbsService.setBreadcrumbs(this.breadcrumbs), 1);
                this.model = new InfoRequest();
                this.model.Where = "motoriDiRicerca";
                this.configuration = componentInfo.ConfigurationInfo;
            }

            initMap() {
                if (google == undefined || google == null || !google) {
                    this.initMap();
                }
                else {
                    var geocoder = new google.maps.Geocoder();
                    var street = this.company.StreetAddress.replace(",", "");
                    var address = street + " - " + this.company.PostalCode + ", " + this.company.City + " (" + this.company.Province + ")";
                    var htmlCode = "<strong>" + this.company.Name + "</strong><br>" + address + "<br> <strong>Telefono:</strong> " + this.company.Phone;
                    geocoder.geocode({ 'address': address }, function (results, status) {

                        var initLongitude = results[0].geometry.location.lng();
                        var initLatitude = results[0].geometry.location.lat();

                        var mapMarkers = [{
                            address: address,
                            html: htmlCode,
                            icon: {
                                image: "/global_app/writefolder/img/pin.png",
                                iconsize: [100, 100],
                                iconanchor: [50, 100]
                            },
                            popup: true
                        }];

                        // Map Initial Location


                        // Map Extended Settings
                        var mapSettings = {
                            controls: {
                                draggable: true,
                                panControl: true,
                                zoomControl: true,
                                mapTypeControl: true,
                                scaleControl: true,
                                streetViewControl: true,
                                overviewMapControl: true
                            },
                            scrollwheel: false,
                            markers: mapMarkers,
                            latitude: initLatitude,
                            longitude: initLongitude,
                            zoom: 18
                        };

                        var map = $("#map").gMap(mapSettings);

                        // Map Center At
                        var mapCenterAt = function (options, e) {
                            e.preventDefault();
                            $("#map").gMap("centerAt", options);
                        }
                    })
                }
            }

            ngAfterViewChecked() {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }

                //-- Set title, setup google analytics and other libraries 
                this.scriptService.setGoogleScripts(this.seoInfo);

                //hiding of loading panel after we get all data we need
                this.routesService.hidePageLoader();

                //this.initMap();

                this.pageIsInit = true;
            }

            ngOnDestroy() {
                //Called once, before the instance is destroyed.
                //Add 'implements OnDestroy' to the class.
                this.subManager.unsubscribe();
            }
        }

        return ChildComponent;
    }
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/components/cms/page/sys/info-request.component.ts